export default __webpack_public_path__ + "static/media/spotlight.0b0c4b63.png";